import { render } from "./Privacy.vue?vue&type=template&id=26cd7998&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=26cd7998&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cd7998"]])

export default __exports__